import { useState,useEffect } from "react";
import {
  useAuthContext,
  useCartContext,
  useProductsContext,
  useWishlistContext,
} from "../../contexts";
import { useLocation, useNavigate } from "react-router";
import { notify, dateFormat2 } from "../../../utils/utils";
import ProductDetails from '../../pages/ProductDetails'
import AddProposal from '../proposal/addProposal'
import commonObj from '../../../utils/Common';
import { LazyLoadImage } from 'react-lazy-load-image-component';


import services from '../../../services/index'
/*********88Added for invoice mail*******/
import config from '../../../config/index';
import axios from '../../../config/axios';
import LinearProgress, {linearProgressClasses} from '@mui/material/LinearProgress';
import { Box, duration} from '@mui/material';
import { styled } from '@mui/material/styles';
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
  },
}));
/*******End*******/
const SingleTransportProduct = ({ product,keyData, imgurl, refId, customerdata={}, usertypeOpenTab='',isMining=0}) => { //console.log('single product', product)
  const { token, userInfo } = useAuthContext();
  //const { isInCart } = useProductsContext();
  const { addProductToCart, disableCart } = useCartContext();
  const { addProductToWishlist, deleteProductFromWishlist, disableWish } =
    useWishlistContext();
  const [showModal, setShowModal] = useState(false);
  const [proposalModal, setProposalModal] = useState(false);
  const [isView, setIsView] = useState('');
  const [rowcolor, setRowColor] = useState('{}');
  const [sellLoad, setSellLoad] = useState('Sell_Now');
  const [progress,setprogress] = useState(0);
  const [pathMatch,setPathMatch] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  //let inCart = isInCart(product.id);
  let CDate = dateFormat2('')
  //let CDate = dateFormat2(product?.proposalDate)
  let dbDate = dateFormat2(product?.proposalDate)

  const labels = isMining
      ? {
          Order_Now: product?.productrefType==9 ? commonObj.getLabel('Buy_Now') : commonObj.getLabel('Sell_Now'),
        }
      : {
          Order_Now: commonObj.getLabel('Order_Now'),
        };

  const CurrencyType = (product?.productCategory===39) ? commonObj.getCurrency('yuan') 
                       : (product?.productCategory===41) ? commonObj.getCurrency('doller') 
                       : commonObj.getCurrency('mn')
  const closeHandler = () => {
    setProposalModal(false)
  }

  const prcount = (c=0) => {
    if(c) product.proposalCount = product?.proposalCount + 1
    return c
  }

  useEffect( () =>{
    let isMatch = /\bproducts\b/.test(location.pathname);
    setPathMatch(isMatch)
  },[prcount])

  const addtocart = () => {
    if(userInfo?.userType==5){
      let proposalObj = {
        productId: product.id,
        fromId: userInfo?.id,
        praposalPrice: product.productPrice,
        refId:refId ? refId: 0,
        productAddedBy:product.addBy,
      }
      addProposalSellNow(proposalObj)
    }else{
      if (product.productCategory==userInfo?.categoryId) {
        addProductToCart(product, imgurl, product.productPrice, null) 
        setTimeout(() => {
          navigate(`/cart`);
        }, 300);
      } else {
        notify("warn", commonObj.getLabel('You_not_register_for_category'));
      }
   }
   
  }  

                                              {/*  OLD Condition
                                                // condition for buy/sell category
                                                  if ( commonObj.getBuysellcatIds(product.productCategory) &&
                                                      userInfo?.userType !== 8 &&
                                                      userInfo?.userType !== 9
                                                  ) {
                                                    notify("warn", commonObj.getLabel("Mining_Buy_Sell_Category_Alert"), { autoClose: 5000});
                                                    return;
                                                  }

                                                  if ( !commonObj.getBuysellcatIds(product.productCategory) &&
                                                      (userInfo?.userType === 8 ||
                                                      userInfo?.userType === 9)
                                                ) {
                                                  notify("warn", commonObj.getLabel("Mining_Buy_Sell_Category_Alert"), { autoClose: 5000});
                                                  return;
                                                }
                                                */}
            
 
 
  const addProposalSellNow = async (proposalObj) => {
    setSellLoad('Loading')
    const proposalRes = await services.proposalService.addProposal([proposalObj]);
    if (proposalRes.status === 1) {
      notify("success", commonObj.getLabel('Proposal_sent'));
      prcount(1)

      let notifUserId =proposalObj.productAddedBy;
      //if(userInfo?.id===proposalObj.productAddedBy) notifUserId = firstFromId || proposalObj.fromId
      //else if(userInfo?.id===proposalObj.fromId) notifUserId = proposalObj.productAddedBy
      await services.notificationService.saveNotification( {moduleId:2,moduleType:'addPraposal', userId:notifUserId, messageData:`You got a new praposal of amount ${proposalObj.praposalPrice} for the product "${product?.productName}"`} )
      setSellLoad('Done')
      closeHandler(false)

      return false
  }
  }

  const handleSellerRedirection = (product) =>{ 

   if (product.productCategory==userInfo?.categoryId) {
        if(userInfo?.id===product.addBy && pathMatch){
        navigate(`/user/myproposals/${product.id}`,{state: {usertypeOpenTab:usertypeOpenTab}})
          return false
        }else if(userInfo?.userType===parseInt(product.productrefType) && pathMatch){ 
          let msg = commonObj.getLabel('Proposal_submission_Same_User_uype')
          if(userInfo?.userType===911) msg = commonObj.getLabel('Proposal_submission_Same_User_uype')
          notify("warn",msg,{duration:5000})
          return false
        }

        setIsView('')
        setProposalModal(true)
      } else {
        notify("warn", commonObj.getLabel('You_not_register_for_category'));
      }
    //console.log('handleSellerRedirection', userInfo?.userType,product.productrefType)
    
  }

  return (
    <>
    
    <tr key={product.productName} className="border border-slate-300" >
      <td className="p-2 text-center font-normal" data-label={commonObj.getLabel('ID')}>
        <span className="cell-mobile-label">{commonObj.getLabel('ID')}</span>
        { keyData+1}
      </td>
      <td className="p-2 text-center w-28 mobile-card-thumb">
        <div className="inline-block h-[3.875rem] w-[3.875rem] rounded-full shadow-sm product-thamnails-image-box">
        

      <LazyLoadImage
        alt={product.productName}
        height="100"
        src={imgurl+product?.productImage} // use normal <img> attributes as props
        effect="blur"
        />
        </div>
          {/* <div className="font-normal">
        product.user?.firstName+' '+product.user?.lastName
        </div>*/}
      </td>
      <td className="p-2 text-center mobile-card-title">
      {product.productName}
      </td>
      {customerdata?.firstName!=undefined && (
      <td className="p-2 text-center" data-label={commonObj.getLabel('Name')}>
        <span className="cell-mobile-label">{commonObj.getLabel('Name')}</span>
        {customerdata?.firstName+' '+customerdata?.lastName}
        <br/><span style={{color:'gray'}}>({product.proposalType})</span>
      </td>
      )}
      <td className="p-2 text-center" data-label={commonObj.getLabel('Transport_Type')}>
        <span className="cell-mobile-label">{commonObj.getLabel('Transport_Type')}</span>
        {product.transportType}
      </td>
      <td className="p-2 text-center" data-label={commonObj.getLabel('From_Where')}>
        <span className="cell-mobile-label">{commonObj.getLabel('From_Where')}</span>
        {product.fromWhere}
      </td>
      <td className="p-2 text-center" data-label={commonObj.getLabel('Qty')}>
        <span className="cell-mobile-label">{commonObj.getLabel('Qty')}</span>
        {product.productQuantity} {commonObj.getLabel('Tonne')}
      </td>
      {product?.UserMyProposal!=undefined ? (
      <td className="p-2 text-center" data-label={commonObj.getLabel('Price')}>
      <span className="cell-mobile-label">{commonObj.getLabel('Price')}</span>
      {CurrencyType}{product.UserMyProposal}/{commonObj.getLabel('Tonne')}
      </td>
      ):(
      <td className="p-2 text-center" data-label={commonObj.getLabel('Price')}>
      <span className="cell-mobile-label">{commonObj.getLabel('Price')}</span>
      {CurrencyType}{product.productPrice}/{commonObj.getLabel('Tonne')}
      </td>
      )}
      {product?.proposalDate!=undefined ? (
      <td className="p-2 text-center" data-label={commonObj.getLabel('Created_Date')}>
        <span className="cell-mobile-label">{commonObj.getLabel('Created_Date')}</span>
        {dbDate}
      </td>
      ) : '' }
            {/* CODE BEFORE ADDING PROPOSAL SYSTEM <td className="p-2 text-center">
                  <span className="font-normal flex justify-center flex-col gap-2 items-center"> 
                  { product?.UserMyProposal===undefined ? (  //hide this in case of my proposal list  
                    <>
                    <a
                      className={`rounded-sm relative px-2 text-sm text-center bg-green-500 text-white hover:bg-green-600 py-1 cursor-pointer`}
                      disabled=""
                      onClick={() => setShowModal(true)}
                      style={{minWidth:135+'px'}}
                            >
                               {commonObj.getLabel('View_Detail')}
                    </a>
                    </>
        ) : '' }
                </span>
                  </td>*/}

      <td className="p-2 text-center" data-label={commonObj.getLabel('Details')}>
        <span className="cell-mobile-label">{commonObj.getLabel('Details')}</span>
        <span className="font-normal flex justify-center flex-col gap-2 items-center"> 
        { product?.UserMyProposal===undefined ? (  //hide this in case of my proposal list  
          <>
          <a
            className={`rounded-full relative p-1 text-sm text-center border border-black w-full hover:text-white hover:border-red  hover:bg-red-700 text-black cursor-pointer`}
            disabled=""
            onClick={() => setShowModal(true)}
            style={{minWidth:135+'px'}}
                  >
                      {commonObj.getLabel('View_Detail')}
          </a>
          </>
        ) : '' }
                         {/* <span className="font-normal flex justify-between items-center">  */}
        { product?.proposalDate===undefined || CDate==dbDate ? (
          <>
            {/* { setRowColor('{background-color: #9eff456b;}') } */}
          <a
            className={`rounded-full relative p-1 text-sm text-center border border-black w-full hover:text-white hover:border-red  hover:bg-red-700 text-black cursor-pointer ${product?.proposalCount || userInfo?.id===product.addBy ? '':''} `}
            disabled={disableCart}
            style={{ backgroundColor: product?.proposalCount>0 || userInfo?.id===product.addBy ? '' : ''}}
            onClick={() => {
              if (!token) {
                navigate("/login", { state: { from: location.pathname } });
                notify("warn", commonObj.getLabel('Please_Login_to_continue'));
              } else {
                handleSellerRedirection(product)
                
              }
            }}
          >
            {product?.proposalCount>0 ? commonObj.getLabel('Go_to_Praposal') : commonObj.getLabel('Add_Praposal')}
            
          </a>  
          </> 
        ) : '' 
        //
        }
            {/* {product?.proposalCount>0 ? <span class=" leading-4 absolute right-2 h-6 w-6 inline-flex items-center  px-2 text-black rounded-full bg-green-300 cursor-pointer" onClick={()=>{setIsView(product?.proposalDate);setProposalModal(true)}}>{product?.proposalCount+prcount()}</span> :'' } */}
        {/* </span> */}
                          
                            
        </span>
      </td>


      <td className="p-2 text-center relative" data-label={commonObj.getLabel('Action')}>
        <span className="cell-mobile-label">{commonObj.getLabel('Action')}</span>
        <a
            className={`rounded-full relative p-2 text-sm text-center border border-black w-full hover:text-white hover:border-red  hover:bg-red-700 text-white bg-black cursor-pointer`}
            //disabled={(product?.productrefType==6) ? true:false}
            onClick={() => {
                if (!token) {
                  navigate("/login", { state: { from: location.pathname } });
                  notify("warn", commonObj.getLabel('Please_Login_to_continue'));
                } else {
                  if (!product?.inCart) {
                    addtocart()
                  } else {
                    navigate("/cart");
                  }
                }
              }}
                  >
                     {labels.Order_Now} 
          </a> 
      </td>                                                     

    </tr>


{showModal ? (
<div>
<div
  className="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full inset-0 h-[calc(100%-1rem)] max-h-full"
>
  <div className="relative p-6 w-2/3 products_detail_popup h-3/6">
    {/*content*/}
    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
      {/*header*/}
      <div className="flex items-start justify-between p-2 px-6 border-b border-solid border-slate-200 rounded-t">
        <h3 className="text-2xl font-semibold">
          {commonObj.getLabel('Product_Details')}
        </h3>
        <button
          className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-2xl leading-none font-semibold outline-none focus:outline-none"
          onClick={() => setShowModal(false)}
        >
          <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
            ×
          </span>
        </button>
      </div>
      {/*body*/}
      <div className="relative p-3 flex-auto">

      <ProductDetails customproductId={product.id} isTransport={true} labels={labels}/>
      </div>
      {/*footer*/}
      <div className="flex items-center justify-end p-2 border-t border-solid border-slate-200 rounded-b">
        <button
          className="text-red-500 background-transparent font-bold uppercase px-2 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
          type="button"
          onClick={() => setShowModal(false)}
        >
          {commonObj.getLabel('Close')}
        </button>
        
      </div>
    </div>
  </div>
</div>
<div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
</div>
) : null}



{proposalModal ? (
<div>
<div
  className="overflow-y-auto float-none overflow-x-hidden fixed top-0 w-full  right-0 left-0 z-50 justify-center items-center inset-0 h-[calc(100%-1rem)] "
>
  <div className=" max-w-md float-none w-1/4 w-96 mx-auto mx-0  relative p-4  max-h-full">
    {/*content*/}
    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
      {/*header*/}
      <div className="flex items-start justify-between p-2 ">
        <h3 className="text-xl font-semibold">
          {commonObj.getLabel('Praposal_Details')}
        </h3>
        <button
          className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
          onClick={() => setProposalModal(false)}
        >
          <span className="bg-transparent text-black opacity-5 text-2xl block outline-none focus:outline-none">
            ×
          </span>
        </button>
      </div>
      {/*body*/}
      <div className="relative flex-auto">

      <AddProposal product={product} sessionId={userInfo?.id} closeHandler={closeHandler} prcount={prcount} isViewDate={isView} refId={refId} imgurl={imgurl}/>
      </div>

    </div>
  </div>
</div>
<div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
</div>
) : null}




</>


  )};

export default SingleTransportProduct;
